import React from "react";
// react component used to create sweet alerts
import SweetAlert from "react-bootstrap-sweetalert";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";


import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.jsx";

class Confirm extends React.Component{
    render(){
        const {text,onCancel,onConfirm}=this.props
        return  <SweetAlert
                warning
                style={{ display: "block", marginTop: "-100px" }}
                title="Are you sure?"
                onConfirm={onConfirm}
                onCancel={onCancel}
                confirmBtnCssClass={
                this.props.classes.button + " " + this.props.classes.success
                }
                cancelBtnCssClass={
                this.props.classes.button + " " + this.props.classes.danger
                }
                confirmBtnText="Confirm"
                cancelBtnText="Cancel"
                showCancel
            >
                {text}
            </SweetAlert>
    }
}
export default withStyles(sweetAlertStyle)(Confirm);



// WEBPACK FOOTER //
// ./src/components/Alert/Confirm.jsx